import { FILTER_TYPES, PAGE_SIZE_FILTER } from 'constants/filterType';

export const PICKLIST_FILTER_OPTIONS = [
  {
    field: 'picklist_status',
    label: 'Picklist Status',
    type: FILTER_TYPES.MULTI_SELECT,
    options: [
      { value: 'created', label: 'Created' },
      { value: 'receiving', label: 'Receiving' },
      { value: 'closed', label: 'Closed' },
    ],
  },
  {
    field: 'picklist_code__icontains',
    label: 'Picklist Code',
    type: FILTER_TYPES.TEXT,
  },
  {
    field: 'created_after',
    label: 'Picklist Created After',
    type: FILTER_TYPES.DATE,
  },
  {
    field: 'created_before',
    label: 'Picklist Created Before',
    type: FILTER_TYPES.DATE,
  },
  { ...PAGE_SIZE_FILTER },
];

export const CREATE_PICKLIST_FILTER_OPTIONS = [
  {
    field: 'total_quantity',
    label: 'Total Quantity',
    type: FILTER_TYPES.TEXT,
  },
  {
    field: 'is_single_sku',
    label: 'Is Single SKU',
    type: FILTER_TYPES.SELECT,
    options: [
      { value: '', label: 'Invoicing' },
      { value: 'true', label: 'Invoicing - Single SKU' },
    ],
  },
  {
    field: 'shipment_code__icontains',
    label: 'Shipment Code',
    type: FILTER_TYPES.TEXT,
  },
  {
    field: 'order_code__icontains',
    label: 'Order Code',
    type: FILTER_TYPES.TEXT,
  },
  {
    field: 'brand__icontains',
    label: 'Brand Name',
    type: FILTER_TYPES.TEXT,
  },
  {
    field: 'product_name__icontains',
    label: 'Product Name',
    type: FILTER_TYPES.TEXT,
  },
  {
    field: 'product_sku__icontains',
    label: 'Product SKU',
    type: FILTER_TYPES.TEXT,
  },
  {
    field: 'payment_type',
    label: 'Payment Type',
    type: FILTER_TYPES.SELECT,
    options: [
      { value: '', label: 'All' },
      { value: 'prepaid', label: 'Prepaid' },
      { value: 'cod', label: 'COD' },
    ],
  },
  {
    field: 'created_after',
    label: 'WMS Created After',
    type: FILTER_TYPES.DATE,
  },
  {
    field: 'created_before',
    label: 'WMS Created Before',
    type: FILTER_TYPES.DATE,
  },
  { ...PAGE_SIZE_FILTER },
];
